export function initVirtualLinks(elems: HTMLElement[]) {
  elems.forEach((elem) => elem.addEventListener('click', openLink))
}

function openLink(this: HTMLElement) {
  window.open(this.dataset.href, '_blank')
}
